import * as c from "fp-ts/lib/Json";
import * as t from "fp-ts/lib/Option";
import { pipe as e, flow as s } from "fp-ts/lib/function";
const r = (o) => e(
  t.tryCatch(() => localStorage.getItem(o)),
  t.chain(t.fromNullable)
), l = (o) => e(
  t.tryCatch(() => localStorage.getItem(o)),
  t.chain(t.fromNullable),
  t.chain(s(c.parse, t.fromEither))
), m = (o) => e(r(o), t.toNullable), n = (o) => e(l(o), t.toNullable), g = (o, a) => {
  e(
    t.tryCatch(
      () => localStorage.setItem(
        o,
        typeof a == "string" ? a : JSON.stringify(a)
      )
    )
  );
}, f = (o) => {
  t.tryCatch(() => localStorage.removeItem(o));
}, i = () => {
  t.tryCatch(() => localStorage.clear());
}, p = {
  get: m,
  set: g,
  safeGet: r,
  clear: i,
  remove: f,
  safeGetJson: l,
  getJson: n
};
export {
  p as _
};
//# sourceMappingURL=local-storage-DzKkZeCG.mjs.map
